module.exports = __webpack_public_path__ + "img/black_chevron_right@2x.67645cc8.png";